import React from 'react'
import { CBadge, CButton } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { icon } from '../shared/icons'
import { request } from '../services'
import { dashboardBaseURL, storageKey } from '../services/config'

// Token Sabre guardado en localStorage: primero la sesion del admin, luego el de Boston IA.
function readStoredToken() {
  try {
    const session = JSON.parse(window.localStorage.getItem(storageKey) || '{}')
    if (session && session.sabreToken) return session.sabreToken
  } catch (_) {}
  try {
    return window.localStorage.getItem('boston_session_token_v1') || ''
  } catch (_) {
    return ''
  }
}

function Topbar({ me, onLogout }) {
  async function logout() {
    await request('logout', { method: 'POST' })
    onLogout()
  }

  // Abre el dashboard con el token (de localStorage) al final de la URL: ...?token=XXXX
  function openDashboard() {
    const token = readStoredToken()
    if (!token) {
      window.alert('No hay token guardado en localStorage. Carga el token Sabre antes de abrir el dashboard.')
      return
    }
    const base = dashboardBaseURL()
    const url = `${base}${base.includes('?') ? '&' : '?'}token=${encodeURIComponent(token)}`
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return (
    <header className="topbar">
      <div className="brand">
        <img className="brand-logo" src={`${process.env.PUBLIC_URL || ''}/bf_large.png`} alt="boston" />
        <CBadge color={me.env === 'STG' ? 'warning' : 'success'}>{me.env}</CBadge>
      </div>
      <div className="spacer" />
      <span className="user-chip">
        <CIcon icon={icon('cilUser')} /> {me.email || 'Usuario'}
      </span>
      <CButton color="primary" variant="outline" size="sm" onClick={openDashboard}>
        <CIcon icon={icon('cilSpeedometer')} /> Dashboard
      </CButton>
      <CButton color="light" size="sm" onClick={logout}>
        <CIcon icon={icon('cilAccountLogout')} /> Salir
      </CButton>
    </header>
  )
}

export default Topbar
